import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../../../ui/Breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import Progress from "../../../ui/Progress";
import TopBar from "./TopBar";
import Box from "../../../ui/Box";
import ScheduleTabs from "./ScheduleTabs";
import SchedViewMainInfo from "./SchedViewMainInfo";
import SchedViewOrgInfo from "./SchedViewOrgInfo";
import useScheduleView from "./useScheduleView";
import PageUnderConstruction from '../../../PageUnderConstruction';

const useStyles = makeStyles(() => ({
  facilityRoot: {
    display: "flex",
    background: "#F6FBFF"
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  },
  mainContent: {
    padding: 8,
    maxWidth: 816
  },
  form: {
    width: 385
  },
  twoColumns: {
    display: "flex"
  },
  maps: {
    marginLeft: 55
  },
  caption: {
    color: "#778899",
    fontSize: 10,
    marginBottom: 16
  },
  photos: {
    width: 774
  }
}));

const items = [
  {
    label: "Расписание ЦОПП региона",
    link: "/work/app/schedule"
  }];

const ScheduleView = ({ match, history }) => {
  const { id } = match.params;
  const classes = useStyles();
  const {
    scheduleData: { scheduleMain },
    setSchedulesData,
    getSchedule
  } = useScheduleView();

  const returnBack = () => history.push("/work/app/schedule");

  useEffect(() => {
    getSchedule(id);
  }, []);

  return (
    <div>
      <Breadcrumbs items={items} />
      {scheduleMain ? (
        <div className={classes.facilityRoot}>
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                reloadProgram={() => getSchedule(id)}
                returnBack={returnBack}
              />
            </div>
            <ScheduleTabs>
              <Box noMargin>
                <SchedViewMainInfo info={scheduleMain}/>
              </Box>
              <Box noMargin>
                <PageUnderConstruction/>
              </Box>
            </ScheduleTabs>
          </div>
        </div>
      ) : (
        <Progress />
      )}
    </div>
  );
};

export default withRouter(ScheduleView);
